// German translations (Deutsch)
export const de = {
  // Navigation
  nav: {
    home: "Startseite",
    rooms: "Zimmer",
    amenities: "Ausstattung",
    gallery: "Galerie",
    virtualTour: "Virtuelle Tour",
    location: "Standort",
    contact: "Kontakt",
    bookNow: "Jetzt Buchen"
  },
  
  // Hero
  hero: {
    tagline: "Familiengeführtes 3-Sterne-Hotel, 2 Minuten vom Velika Plaža, Ulcinj",
    description: "Ein einfaches, familiengeführtes 3-Sterne-Hotel am Kepi i Gjeranave, etwa 2 Gehminuten vom Sand am Anfang des Velika Plaža, dem 12 km langen Strand von Ulcinj. Frühstück, Abendessen, Pool, WLAN und Garage sind inklusive. Die Zimmer sind sauber und zweckmäßig, nicht luxuriös – die meisten mit Balkon, viele mit Meerblick.",
    exploreRooms: "Zimmer Erkunden",
    viewGallery: "Galerie Ansehen",
    veryGood: "Sehr Gut",
    reviews: "Bewertungen",
    starHotel: "3-Sterne-Hotel",
    bookDirect: "Direkt buchen & sparen",
    bestPrice: "Günstiger als Booking.com für dasselbe Zimmer",
    freeCancellation: "Kostenlose Stornierung bei flexiblen Raten",
    noBookingFees: "Keine Buchungsgebühren",
    checkAvailability: "Verfügbarkeit prüfen →"
  },
  
  // Booking
  booking: {
    checkAvailability: "Verfügbarkeit Prüfen & Buchen",
    checkIn: "Anreise",
    checkOut: "Abreise",
    adults: "Erwachsene",
    children: "Kinder",
    adult: "Erwachsener",
    child: "Kind",
    searchAvailability: "Verfügbarkeit Suchen",
    secureBooking: "Sichere Buchung • Bestpreisgarantie • Kostenlose Stornierung bei den meisten Zimmern",
    freeCancellation: "Kostenlose Stornierung bei den meisten Buchungen"
  },
  
  // Rooms
  rooms: {
    title: "Einfache, saubere Zimmer am Strand",
    subtitle: "Unterkünfte",
    description: "13 Zimmertypen vom kompakten Einzelzimmer bis zum Apartment mit zwei Schlafzimmern. Jedes Zimmer hat Klimaanlage, eigenes Bad und kostenloses WLAN; die meisten einen Balkon. Die Möbel sind zweckmäßig, kein Design.",
    viewDetails: "Details Ansehen",
    bookNow: "Jetzt Buchen",
    perNight: "/Nacht",
    guests: "Gäste",
    backToRooms: "Zurück zu Allen Zimmern",
    roomAmenities: "Zimmerausstattung",
    standardFeatures: "Standardausstattung"
  },
  
  // Room Names
  roomNames: {
    room1: "Doppelzimmer mit Meerblick und Balkon",
    room2: "Doppelzimmer am Pool",
    room3: "Economy Doppelzimmer mit Balkon (ohne Aussicht)",
    room4: "Zweibettzimmer mit Meerblick und Gemeinschaftsterrasse",
    room5: "Executive Dreibettzimmer mit Meerblick und Balkon",
    room6: "Doppelzimmer mit Zustellbett - Meerblick und Balkon",
    room7: "Zwei-Zimmer-Familienapartment",
    room8: "Familienzimmer mit Gemeinschaftsterrasse",
    room9: "Familienzimmer mit Terrasse",
    room10: "Kleines Einzelzimmer",
    room11: "Dreibettzimmer mit Balkon",
    room12: "Familienzimmer mit Bergblick",
    room13: "Ein-Zimmer-Apartment"
  },
  
  // Amenities
  amenities: {
    title: "Hotelausstattung",
    subtitle: "Was Wir Bieten",
    beachfront: "Strandlage",
    beachfrontDesc: "Direkter Zugang zum Long Beach",
    childrenPool: "Kinderpool",
    childrenPoolDesc: "Sicherer Pool für Familien",
    restaurant: "Restaurant & Café",
    restaurantDesc: "Balkan-Küche · alkoholfrei",
    wifi: "Kostenloses WLAN",
    wifiDesc: "Schnelles Internet",
    parking: "Kostenloser Parkplatz",
    parkingDesc: "Sicheres Parken",
    shuttle: "Flughafentransfer",
    shuttleDesc: "€80 von Podgorica & Tivat (auf Anfrage)",
    frontDesk: "24-Stunden-Rezeption",
    frontDeskDesc: "24/7 Service",
    elevator: "Aufzug",
    elevatorDesc: "Alle Etagen"
  },
  
  // Gallery
  gallery: {
    intro: "Entdecken Sie die Schönheit des Hotels La Rosa Negra und den Charme von Ulcinj.",
    title: "Fotogalerie",
    subtitle: "Unser Hotel Erkunden",
    all: "Alle",
    rooms: "Zimmer",
    pool: "Pool",
    beach: "Strand",
    restaurant: "Restaurant",
    exterior: "Außenbereich"
  },
  
  // Virtual Tour
  virtualTour: {
    title: "360° Virtuelle Tour",
    subtitle: "Unser Hotel Erleben",
    description: "Machen Sie einen virtuellen Rundgang durch unser schönes Hotel"
  },
  
  // Location
  location: {
    title: "Unser Standort",
    subtitle: "Finden Sie Uns",
    address: "Adresse",
    nearbyAttractions: "Sehenswürdigkeiten in der Nähe"
  },
  
  // Contact
  contact: {
    title: "Kontaktieren Sie Uns",
    subtitle: "Schreiben Sie Uns",
    name: "Name",
    email: "E-Mail",
    message: "Nachricht",
    send: "Nachricht Senden",
    phone: "Telefon",
    whatsapp: "WhatsApp"
  },
  
  // FAQ
  faq: {
    intro: "Antworten auf häufige Fragen zum Hotel La Rosa Negra.",
    title: "Häufig Gestellte Fragen",
    subtitle: "FAQ"
  },
  
  // Footer
  footer: {
    quickLinks: "Schnelllinks",
    contactInfo: "Kontaktinformationen",
    followUs: "Folgen Sie Uns",
    rights: "Alle Rechte vorbehalten",
    starHotel: "Sterne-Hotel",
    description: "Erleben Sie die perfekte Mischung aus mediterranem Charme und modernem Komfort direkt am Velika Plaža (Langer Strand), Ulcinj, Montenegro.",
    rooms: "Zimmer & Suiten",
    amenities: "Ausstattung",
    gallery: "Galerie",
    location: "Lage",
    reviews: "Bewertungen",
    legal: "Rechtliches",
    privacy: "Datenschutz",
    terms: "AGB",
    cookies: "Cookie-Richtlinie",
    cancellation: "Stornierungsbedingungen"
  },

  // Smart language-hint toast
  langHint: {
    message: "Diese Seite ist auch auf Deutsch verfügbar",
    switch: "Wechseln",
    dismiss: "Schließen"
  },
  
  // Why Book Direct
  whyBookDirect: {
    eyebrow: "Direkt buchen",
    heading: "Warum direkt buchen?",
    lead: "Hier kostet es weniger als auf Booking.com und Sie haben direkt mit uns zu tun – das bekommen Sie genau",
    b1t: "Günstiger als Booking.com",
    b1d: "Unser Direktpreis liegt 10 % unter unserem Booking.com-Preis für dasselbe Zimmer und dieselben Daten. Dort günstiger gefunden? Link schicken, wir gleichen an.",
    b2t: "10% Rabatt",
    b2d: "Die 10 % sind bereits im angezeigten Preis – kein Code, keine Zusatzgebühren.",
    b3t: "Klare Stornobedingungen",
    b3d: "Flexible Raten sind bis zum im Buchungsschritt angezeigten Datum kostenlos stornierbar; nicht erstattbare Raten sind vor der Zahlung klar gekennzeichnet.",
    b4t: "Ein Mensch antwortet",
    b4d: "WhatsApp, Telefon oder E-Mail – unsere Rezeption antwortet meist innerhalb weniger Stunden, 08:00–23:00.",
    cta: "Direkt buchen & sparen"
  },

  // Amenities section headings/CTA
  amenitiesSection: {
    eyebrow: "Ausstattung",
    heading: "Was das Hotel hat",
    lead: "Die Einrichtungen, die wirklich da sind – nicht mehr, nicht weniger.",
    ctaTitle: "Fragen vor der Buchung?",
    ctaLead: "Fragen Sie uns alles zu Zimmern, Strand oder Anreise – wir antworten ehrlich.",
    ctaButton: "Concierge kontaktieren"
  },

  // Contact section
  contactForm: {
    title: "Schreiben Sie dem richtigen Team",
    subtitle: "Wählen Sie eine Abteilung – wir antworten innerhalb eines Werktags.",
    dep_sales: "Vertrieb", hint_sales: "Gruppenbuchungen, Events, Firmenraten, Reisebüros",
    dep_jobs: "Bewerbung", hint_jobs: "Senden Sie uns Ihren Lebenslauf – Rezeption, Housekeeping, F&B, Technik",
    dep_pr: "Presse & PR", hint_pr: "Presse, Medien, Partnerschaften und Kooperationen",
    name: "Ihr Name", email: "E-Mail-Adresse", phone: "Telefon (optional)", subject: "Betreff", position: "Position, auf die Sie sich bewerben",
    message: "Ihre Nachricht", messageJobs: "Erzählen Sie uns von sich, Ihrer Erfahrung und Verfügbarkeit",
    attachCv: "Lebenslauf anhängen (PDF oder Word, max. 5 MB)", send: "Nachricht senden",
    successTitle: "Nachricht gesendet!", successBody: "Vielen Dank – Ihre Nachricht ist angekommen bei:", sendAnother: "Weitere Nachricht senden",
    error: "Senden fehlgeschlagen. Bitte erneut versuchen.", privacy: "Wir nutzen Ihre Daten nur zur Beantwortung Ihrer Anfrage."
  },
  contactSection: {
    eyebrow: "Kontaktieren Sie uns",
    heading: "Nehmen Sie Kontakt auf",
    lead: "Haben Sie Fragen? Wir sind hier, um zu helfen. Erreichen Sie uns jederzeit.",
    addressLabel: "Adresse",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    receptionLabel: "Rezeptionszeiten",
    reception247: "24/7 - Wir sind immer für Sie da",
    whatsappBtn: "WhatsApp-Chat",
    emailBtn: "E-Mail senden",
    bookDirectTitle: "Direkt buchen & sparen",
    bookDirectDesc: "Erhalten Sie 10% Rabatt bei Buchung über unsere Website",
    checkAvailability: "Verfügbarkeit prüfen",
    whatsappPrefill: "Hallo, ich möchte mich über das Hotel La Rosa Negra erkundigen"
  },

  // Reviews section
  reviews: {
    eyebrow: "Gästebewertungen",
    heading: "Was Gäste sagen – unverändert",
    lead: "Bewertungen werden wörtlich von Booking.com übernommen, auch die kritischen Teile. Urteilen Sie selbst.",
    veryGood: "Sehr gut",
    reviewsCount: "Bewertungen",
    starHotel: "3-Sterne-Hotel",
    readMoreOn: "Mehr Bewertungen lesen auf",
    translatedFrom: "Übersetzt aus dem {lang}",
    showOriginal: "Original anzeigen",
    showTranslation: "Übersetzung anzeigen"
  },

  // Handoff
  handoff: {
    prompt: "Möchten Sie lieber mit unserem Team chatten?",
    button: "Auf WhatsApp fortsetzen",
    prefix: "Hallo Hotel La Rosa Negra! Ich habe mit Ihrem Website-Assistenten gechattet und würde gerne mit einer Person weitermachen."
  },

  // Common
  common: {
    learnMore: "Mehr Erfahren",
    seeAll: "Alle Ansehen",
    close: "Schließen",
    loading: "Laden..."
  }
};
